export const TITLES = [
    { value: 'นาย', label: 'นาย'},
    { value: 'นาง', label: 'นาง'},
    { value: 'นางสาว', label: 'นางสาว'}
]

export const RELATIONS = [
    { value: 'R01', label: 'บิดา'},
    { value: 'R02', label: 'มารดา'},
    { value: 'R03', label: 'คู่สมรส'},
    { value: 'R04', label: 'บุตร'},
    { value: 'R05', label: 'พี่'},
    { value: 'R06', label: 'น้อง'},
    { value: 'R07', label: 'ปู่'},
    { value: 'R08', label: 'ย่า'},
    { value: 'R09', label: 'ตา'},
    { value: 'R10', label: 'ยาย'},
    { value: 'R11', label: 'หลาน'},
    { value: 'R12', label: 'ลุง'},
    { value: 'R13', label: 'ป้า'},
    { value: 'R14', label: 'น้า'},
    { value: 'R15', label: 'อา'}
]


export const RELATIONS_EN = [
    { value: 'R51', label: 'Father'},
    { value: 'R52', label: 'Mother'},
    { value: 'R53', label: 'Spouse'},
    { value: 'R54', label: 'Son'},
    { value: 'R55', label: 'Duaghter'},
    { value: 'R56', label: 'Brother'},
    { value: 'R57', label: 'Sister'},
    { value: 'R58', label: 'Grandfather'},
    { value: 'R59', label: 'Grandmother'},
    { value: 'R60', label: 'Grandchild'},
    { value: 'R61', label: 'Uncle'},
    { value: 'R62', label: 'Aunt'}
]